module.exports = __webpack_public_path__ + "img/logo.c2d93287.png";